import Store from "@/store";
import { getCurrentUser, fetchAuthSession, signOut } from "aws-amplify/auth";

export const forceLogout = async () => {
  try {
    await signOut({ global: false });
  } catch (e) {
    console.error("Sign out error:", e);
  }

  localStorage.clear();
  sessionStorage.clear();

  try {
    const dbs = await indexedDB.databases();
    for (const db of dbs) {
      if (db.name) {
        indexedDB.deleteDatabase(db.name);
      }
    }
  } catch (dbError) {
    console.error("Failed to clear IndexedDB:", dbError);
  }

  window.location.href = "/login";
};

export const AuthFilter = async (to, from, next) => {
  try {
    const [user, session] = await Promise.all([getCurrentUser(), fetchAuthSession()]);

    if (!session.tokens || !session.tokens.idToken) {
      console.warn("User is authenticated but tokens are missing.");
      await forceLogout();
      return;
    }

    const idToken = session.tokens?.idToken;
    const tenantRoles = idToken?.payload?.["custom:roles"];
    const isSuperAdmin = idToken?.payload?.["custom:superadmin"] === "true";
    const name = idToken?.payload?.["name"];

    if (!tenantRoles && !isSuperAdmin) {
      Store.commit("auth/setUser", null);
      if (to.name !== "login") {
        await Store.dispatch("showNotification", {
          title: "Zugriff verweigert",
          text: "Keine Berechtigungen gefunden (NO_TENANT_ROLES). Bitte erneut anmelden oder Support kontaktieren.",
          type: "error",
        });
        await forceLogout();
      } else {
        next();
      }
      return;
    }

    Store.commit("auth/setUser", {
      ...user,
      roles: tenantRoles,
      isSuperAdmin: isSuperAdmin,
      idToken: idToken.toString(),
      name: name,
    });

    // Only on the login -> app transition. Saving it is worth ~100ms once per
    // session and it looks like it guards a post-login race, so it stays.
    if (from.name === "login") {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    if (to.name === "login") {
      next({ name: "devices" });
    } else {
      next();
    }
  } catch (error) {
    console.log("AuthFilter: User is not authenticated or session invalid.", error.message);
    Store.commit("auth/setUser", null);

    if (to.name !== "login") {
      next({ name: "login", query: { redirect: to.fullPath } });
    } else {
      next();
    }
  }
};
